module.exports = __webpack_public_path__ + "static/img/6298_phase_function_Paper_Points.20bd6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6298_phase_function_Paper_Points.png
// module id = yF1l
// module chunks = 0